module.exports = __webpack_public_path__ + "media/images/page_not_found-607d04915c444b78b913d4d2e741b656.svg";